export const trackLoadingWhitelist = [
  'app/setupNavPromotionsRequest',
  'urlPromotion/getPromotionById',
  'promotions/requestLocations',
  'promotions/requestCategories',
  'promotions/checkUrl',
  'promoCodes/requestLocations',
  // URL Promo load tracking
  'urlPromotion/checkUrlChangePossibility',
  'urlPromotion/updateUrlPromotion',
  // Image Promo load tracking
  'imagePromotion/getPromotionById',
  'imagePromotion/checkUrlChangePossibility',
  'connectedProfiles/loadPhonesAndProfiles',
  'connectedProfiles/loadPhoneNumbers',
  'connectedProfiles/loadMoreProfiles',
  'connectedProfiles/loadReviews',
  'connectedProfiles/loadMoreReviews',
  'connectedProfiles/loadQuestions',
  'connectedProfiles/loadMoreQuestions',
  'connectedProfiles/filterSelect',
  'favorites/loadUserSubscriptions',
  'profile/getCurrentUserInfo',
  'profile/getProfile',
  'profile/loadNotifications',
  'profile/loadMoreNotifications',
  'profile/removeNotification',
  'profile/setAllNotifactionsAsReaded',
  'profile/removeAllNotifications',
  'importApi/loadImportHistory',
  'importApi/loadImportedWebsitesIfNeeded',
  'importApi/getMoreHistory',
  'importApi/loadHistoryLogs',
  'importApi/loadMoreHistoryLogs',
];
